import { utcStr2Show } from "../components/StyleControl";
import {
  getLiuYue,
  getFullYearInfo,
  SHI_CHEN_NAMES,
} from "../utils/baziCalculator";

export default function toMarkdown(obj) {
  const birthShow = utcStr2Show(obj.birthday_str);

  const headerInfo = `<!-- 
数据来源：凡心八字在线排盘
网站地址：https://bagezi.top

使用方式：
   1. 复制本文档全部内容
   2. 打开 ChatGPT / Claude / Kimi / DeepSeek / 豆包 等 AI 助手
   3. 粘贴并发送，即可进行命理分析

适用场景：
   - 八字命理基础分析（性格、事业、财运、婚姻）
   - 大运流年运势预测（十年大运、每年运势走向）
   - 流月流日精细分析（月度/每日运势提醒）
   - 重要决策择日参考（签约、搬家、出行等）
   - 五行喜忌与调理建议（颜色、方位、行业）

特别声明：所有内容仅供娱乐参考，请勿轻信封建迷信，请理性看待传统文化，人生道路需靠自己脚踏实地努力。
-->

以下是我的八字命盘数据，请基于这些信息为我进行命理分析：

---
`;

  const baseInfo = `
# 基本信息
姓名：${obj.name}
性别：${obj.gender}
生肖：${obj.sheng_xiao}
生日：${birthShow}
`;
  const nian = obj.nian_zhu;
  const yue = obj.yue_zhu;
  const ri = obj.ri_zhu;
  const shi = obj.shi_zhu;

  const baZiSiZhu = `
# 八字排盘
|日期|年柱|月柱|日柱|时柱|
|----|----|----|----|----|
|主星|${nian.gan_shen}|${yue.gan_shen}|${ri.gan_shen}|${shi.gan_shen}|
|天干|${nian.gan}|${yue.gan}|${ri.gan}|${shi.gan}|
|地支|${nian.zhi}|${yue.zhi}|${ri.zhi}|${shi.zhi}|
|藏干|${nian.zhi_canggan}|${yue.zhi_canggan}|${ri.zhi_canggan}|${shi.zhi_canggan}|
|副星|${nian.zhi_shen}|${yue.zhi_shen}|${ri.zhi_shen}|${shi.zhi_shen}|
`;

  let daYunInfo = `
# 大运
${obj.qiyun_str}
|开始年份|天干|地支|地支藏干|天干十神|地支十神|
|-------|----|----|-------|-------|-------|
`;

  for (const [year, zhu] of Object.entries(obj.da_yun)) {
    const yun = zhuToRow(year, zhu);
    daYunInfo += yun;
  }

  let liuNianInfo = `
# 流年
|流年|天干|地支|地支藏干|天干十神|地支十神|
|-------|----|----|-------|-------|-------|
`;

  for (const [year, zhu] of Object.entries(obj.liu_nian)) {
    const yun = zhuToRow(year, zhu);
    liuNianInfo += yun;
  }

  const mingPanAll = `${headerInfo}
${baseInfo}
${baZiSiZhu}
${daYunInfo}
${liuNianInfo}
`;

  return mingPanAll;
}

function zhuToRow(year, zhu) {
  const row = `|${year}|${zhu.gan}|${zhu.zhi}|${zhu.zhi_canggan}|${zhu.gan_shen}|${zhu.zhi_shen}|`;
  return row + "\n";
}

/**
 * 根据选项生成 Markdown
 * @param {Object} obj - 八字排盘数据
 * @param {Object} options - 导出选项
 * @param {number[]} options.daYunYears - 选中大运年份列表
 * @param {number[]} options.liuNianYears - 选中流年年份列表
 * @param {boolean} options.includeLiuYue - 是否包含流月
 * @param {boolean} options.includeLiuRi - 是否包含流日
 * @param {boolean} options.includeLiuShi - 是否包含流时
 * @param {Object} [options.currentSelection] - 当前选中的流月流日流时信息
 */
export function toMarkdownWithOptions(obj, options) {
  const birthShow = utcStr2Show(obj.birthday_str);

  const headerInfo = `<!-- 
数据来源：凡心八字在线排盘
网站地址：https://bagezi.top

使用方式：
   1. 复制本文档全部内容
   2. 打开 ChatGPT / Claude / Kimi / DeepSeek / 豆包 等 AI 助手
   3. 粘贴并发送，即可进行命理分析

特别声明：所有内容仅供娱乐参考，请勿轻信封建迷信，请理性看待传统文化，人生道路需靠自己脚踏实地努力。
-->

以下是我的八字命盘数据，请基于这些信息为我进行命理分析：

---
`;

  const baseInfo = `
# 基本信息
姓名：${obj.name}
性别：${obj.gender}
生肖：${obj.sheng_xiao}
生日：${birthShow}
`;

  const nian = obj.nian_zhu;
  const yue = obj.yue_zhu;
  const ri = obj.ri_zhu;
  const shi = obj.shi_zhu;

  const baZiSiZhu = `
# 八字排盘
|日期|年柱|月柱|日柱|时柱|
|----|----|----|----|----|
|主星|${nian.gan_shen}|${yue.gan_shen}|${ri.gan_shen}|${shi.gan_shen}|
|天干|${nian.gan}|${yue.gan}|${ri.gan}|${shi.gan}|
|地支|${nian.zhi}|${yue.zhi}|${ri.zhi}|${shi.zhi}|
|藏干|${nian.zhi_canggan}|${yue.zhi_canggan}|${ri.zhi_canggan}|${shi.zhi_canggan}|
|副星|${nian.zhi_shen}|${yue.zhi_shen}|${ri.zhi_shen}|${shi.zhi_shen}|
`;

  let result = `${headerInfo}\n${baseInfo}\n${baZiSiZhu}\n`;

  // 大运
  if (options.daYunYears && options.daYunYears.length > 0) {
    result += `# 大运\n${obj.qiyun_str}\n|开始年份|天干|地支|地支藏干|天干十神|地支十神|\n|-------|----|----|-------|-------|-------|\n`;
    for (const year of options.daYunYears) {
      const zhu = obj.da_yun[year];
      if (zhu) {
        result += zhuToRow(year, zhu);
      }
    }
    result += "\n";
  }

  // 流年
  if (options.liuNianYears && options.liuNianYears.length > 0) {
    result += `# 流年\n|流年|天干|地支|地支藏干|天干十神|地支十神|\n|-------|----|----|-------|-------|-------|\n`;
    for (const year of options.liuNianYears) {
      const zhu = obj.liu_nian[year];
      if (zhu) {
        result += zhuToRow(year, zhu);
      }
    }
    result += "\n";
  }

  // 流月：导出所有选中流年的全部12个月
  if (options.includeLiuYue && options.liuNianYears && options.liuNianYears.length > 0) {
    result += `# 流月\n|流年|月份|天干|地支|地支藏干|天干十神|地支十神|\n|----|----|----|----|-------|-------|-------|\n`;
    for (const year of options.liuNianYears) {
      const liuYue = getLiuYue(obj.ri_gan, year);
      for (let m = 1; m <= 12; m++) {
        const zhu = liuYue[m];
        result += `|${year}|${m}月|${zhu.gan}|${zhu.zhi}|${zhu.zhi_canggan}|${zhu.gan_shen}|${zhu.zhi_shen}|\n`;
      }
    }
    result += "\n";
  }

  // 流日：导出所有选中流年的所有农历月内的每一天
  if (options.includeLiuRi && options.liuNianYears && options.liuNianYears.length > 0) {
    result += `# 流日\n|流年|日期|天干|地支|地支藏干|天干十神|地支十神|\n|----|----|----|----|-------|-------|-------|\n`;
    for (const year of options.liuNianYears) {
      const yearInfo = getFullYearInfo(obj.ri_gan, year, options.jieQiCache?.[year]);
      for (let m = 1; m <= 12; m++) {
        const monthInfo = yearInfo[m];
        if (!monthInfo || !monthInfo.liuRi) continue;
        for (const [dayKey, zhu] of Object.entries(monthInfo.liuRi)) {
          result += `|${year}|${dayKey}|${zhu.gan}|${zhu.zhi}|${zhu.zhi_canggan}|${zhu.gan_shen}|${zhu.zhi_shen}|\n`;
        }
      }
    }
    result += "\n";
  }

  // 流时：导出所有选中流年的所有农历月内的每一天的每个时辰
  if (options.includeLiuShi && options.liuNianYears && options.liuNianYears.length > 0) {
    result += `# 流时\n|流年|日期|时辰|天干|地支|地支藏干|天干十神|地支十神|\n|----|----|----|----|----|-------|-------|-------|\n`;
    for (const year of options.liuNianYears) {
      const yearInfo = getFullYearInfo(obj.ri_gan, year, options.jieQiCache?.[year]);
      for (let m = 1; m <= 12; m++) {
        const monthInfo = yearInfo[m];
        if (!monthInfo || !monthInfo.liuRi) continue;
        for (const [dayKey, zhu] of Object.entries(monthInfo.liuRi)) {
          if (!zhu.liuShi) continue;
          for (let s = 0; s < 12; s++) {
            const shiZhu = zhu.liuShi[s];
            result += `|${year}|${dayKey}|${SHI_CHEN_NAMES[s]}|${shiZhu.gan}|${shiZhu.zhi}|${shiZhu.zhi_canggan}|${shiZhu.gan_shen}|${shiZhu.zhi_shen}|\n`;
          }
        }
      }
    }
    result += "\n";
  }

  return result.trim() + "\n";
}


